import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";

export const useExternalAPILogData = () => {
    const getExternalAPILogData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}external-api-log${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const postExternalAPILogData = async (url: string, payload: any) => {
        try {
            let response;
            if (payload == null) {
                response = await axios.post(`${BASE_URL}external-api-log${url && url}`)
            } else {
                response = await axios.post(`${BASE_URL}external-api-log${url}`, payload)
            };
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const putExternalAPILogData = async (url: string, payload: any) => {
        try {
            let response = await axios.put(`${BASE_URL}external-api-log${url && url}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const patchExternalAPILogData = async (url: string, payload?: any) => {
        try {
            let response = await axios.patch(`${BASE_URL}external-api-log${url && url}`, payload && payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const deleteExternalAPILogData = async (url: string) => {
        try {
            let response = await axios.delete(`${BASE_URL}external-api-log${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };


    return {
        getExternalAPILogData,
        postExternalAPILogData,
        putExternalAPILogData,
        patchExternalAPILogData,
        deleteExternalAPILogData
    };

};